import { render, staticRenderFns } from "./mbdrDialog.vue?vue&type=template&id=41d5295e&scoped=true&"
import script from "./mbdrDialog.vue?vue&type=script&lang=js&"
export * from "./mbdrDialog.vue?vue&type=script&lang=js&"
import style0 from "./mbdrDialog.vue?vue&type=style&index=0&id=41d5295e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d5295e",
  null
  
)

export default component.exports